if (!customElements.get('collection-description-read-more')) {
    class CollectionDescriptionReadMore extends HTMLElement {
        constructor() {
            super();
            this.isExpanded = false;
            this.resizeTimer = null;
            this.handleToggle = this.handleToggle.bind(this);
            this.handleResize = this.handleResize.bind(this);
            this.handleFocusIn = this.handleFocusIn.bind(this);
            this.handleContentLoad = this.handleContentLoad.bind(this);
        }

        connectedCallback() {
            this.content = this.querySelector('[data-collection-description-content]');
            this.toggle = this.querySelector('[data-collection-description-toggle]');
            this.toggleText = this.querySelector('[data-collection-description-toggle-text]');

            if (!this.content || !this.toggle || !this.toggleText) return;

            this.showMoreText = this.toggle.dataset.showMoreText;
            this.showLessText = this.toggle.dataset.showLessText;
            this.toggle.addEventListener('click', this.handleToggle);
            this.content.addEventListener('focusin', this.handleFocusIn);
            this.content.addEventListener('load', this.handleContentLoad, true);
            window.addEventListener('resize', this.handleResize);

            requestAnimationFrame(() => this.refresh());

            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(() => this.refresh());
            }
        }

        disconnectedCallback() {
            if (!this.toggle || !this.content) return;

            this.toggle.removeEventListener('click', this.handleToggle);
            this.content.removeEventListener('focusin', this.handleFocusIn);
            this.content.removeEventListener('load', this.handleContentLoad, true);
            window.removeEventListener('resize', this.handleResize);
            window.clearTimeout(this.resizeTimer);
        }

        getCollapsedHeight() {
            const value = getComputedStyle(this).getPropertyValue('--collection-description-collapsed-height');
            return Number.parseFloat(value) || 420;
        }

        refresh() {
            if (!this.content || !this.toggle) return;

            const shouldCollapse = this.content.scrollHeight > this.getCollapsedHeight() + 1;
            this.classList.toggle('is-collapsible', shouldCollapse);
            this.toggle.hidden = !shouldCollapse;

            if (shouldCollapse) {
                this.setExpanded(this.isExpanded);
            } else {
                this.isExpanded = false;
                this.classList.remove('is-expanded');
                this.toggle.setAttribute('aria-expanded', 'false');
                this.toggleText.textContent = this.showMoreText;
            }
        }

        setExpanded(expanded) {
            this.isExpanded = expanded;
            this.classList.toggle('is-expanded', expanded);
            this.toggle.setAttribute('aria-expanded', String(expanded));
            this.toggleText.textContent = expanded ? this.showLessText : this.showMoreText;
        }

        handleToggle() {
            this.setExpanded(!this.isExpanded);
        }

        handleFocusIn(event) {
            if (this.isExpanded || !this.classList.contains('is-collapsible')) return;

            const contentBottom = this.content.getBoundingClientRect().bottom;
            const focusedBottom = event.target.getBoundingClientRect().bottom;

            if (focusedBottom > contentBottom) this.setExpanded(true);
        }

        handleContentLoad() {
            this.refresh();
        }

        handleResize() {
            window.clearTimeout(this.resizeTimer);
            this.resizeTimer = window.setTimeout(() => this.refresh(), 120);
        }
    }

    customElements.define('collection-description-read-more', CollectionDescriptionReadMore);
}
